export type DotGridColorTheme = {
    base: [number, number, number];
    bright: [number, number, number];
};

export type RippleRing = { delay: number; duration: number; intensity: number };

export type DotGridCanvasHandle = {
    triggerRipple: (rings: RippleRing[]) => void;
};

export const SUBTLE_RING: RippleRing[] = [{ delay: 0, duration: 6000, intensity: 0.325 }];
